<template>
  <router-view />
</template>

<script>
export default {
  name: "craftsmanship",
};
</script>